import { useState } from "react";
import { observer } from "mobx-react-lite";
import { CarStep, CarStore } from "../shared/store/car-store";
import { WidgetContextProvider } from "../shared/context-provider/context-provider";
import { FormFirstVehicle } from "./forms/form-first-vehicle";
import { FormTwoDetails } from "./forms/form-two-details";
import { FormFeedback } from "./forms/form-feedback";
import "./styles/styles.scss";

const mapCarWidgetRender = {
  [CarStep.FormVehicle]: <FormFirstVehicle />,
  [CarStep.FormDetails]: <FormTwoDetails />,
  [CarStep.FormThanks]: <FormFeedback />,
};

export const CarWidget = observer(() => {
  const [carStore] = useState(() => new CarStore());
  return (
    <div className={"container-widget"}>
      <WidgetContextProvider store={carStore}>
        {mapCarWidgetRender[carStore.step]}
      </WidgetContextProvider>
    </div>
  );
});
